import { render, staticRenderFns } from "./ChainBPBarCpuExecutionTime.vue?vue&type=template&id=379671aa"
import script from "./ChainBPBarCpuExecutionTime.vue?vue&type=script&lang=js"
export * from "./ChainBPBarCpuExecutionTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports